export const extractColor = (
  attributesArray: Record<string, string>,
): string => {
  const colorKeys = ["Kolor"];

  for (const key of colorKeys) {
    if (attributesArray[key]) {
      return attributesArray[key];
    }
  }

  return "";
};
